import { Component, Input, OnInit } from '@angular/core';
import { Configs } from '../chart-configs';
import { EventService } from 'src/app/services/event.service';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'report-donut-data',
  templateUrl: './donut-data.component.html',
  styleUrls: ['./donut-data.component.scss']
})
export class DonutDataComponent implements OnInit {
  /**
   * The Event with the most Reservations
   */
  @Input() top1Event: any;
  /**
 * The Event with the 2nmost Reservations
 */
  @Input() top2Event: any;
  /**
 * The Event with the 3rdmost Reservations
 */
  @Input() top3Event: any;
  /**
   * The Event with the least Reservations
   */
  @Input() flop1Event: any;
  /**
   * The Event with the 2ndleast Reservations
   */
  @Input() flop2Event: any;
  /**
   * The Event with the 3rdleast Reservations
   */
  @Input() flop3Event: any;
  /**
   * has the Data been loaded
   */
  LoadingFlopsAndTops: boolean = true;
  /**
   * the Data of the Donut (top 1 Event)
   */
  data_donut_1 = [];
  /**
   * the Data of the Donut (top 2 Event)
   */
  data_donut_2 = [];
  /**
   * the Data of the Donut (top 3 Event)
   */
  data_donut_3 = [];
  /**
   * the Data of the Donut (flop 1 Event)
   */
  data_donut_1_flop = [];
  /**
   * the Data of the Donut (flop 2 Event)
   */
  data_donut_2_flop = [];
  /**
   * the Data of the Donut (flop 3 Event)
   */
  data_donut_3_flop = [];
  /**
   * The Config of the Chart
   */
  config_donut = Configs.config_donut;
  /**
   * The Filter of the Events
   */
  eventFilter = ["ACTIVE", 'HIDDEN'];
  /**
   * The Count of all Reservatios
   */
  allEventsSortedBytotalActiveReservationsCount = [];
  /**
   * Less than 1 Event
   */
  notEnoughEvents: boolean = false;
  /**
   * constructor
   * @param eventService 
   */
  constructor(private eventService: EventService) {

  }

  /**
   * ngOnInit
   * getTopThreeEvents
   */
  ngOnInit() {
    this.eventService.getTopThreeEvents(this.eventFilter, null, null, null).pipe(
      catchError(err => of(err)),
    ).subscribe(allEventsSorted => {
      this.allEventsSortedBytotalActiveReservationsCount = allEventsSorted;
      if (allEventsSorted.length == 0) {
        this.notEnoughEvents = true;
      } else {
        if (allEventsSorted.length >= 1) {
          this.top1Event = allEventsSorted[0];
        }
        if (allEventsSorted.length >= 2) {
          this.top2Event = allEventsSorted[1];
        }
        if (allEventsSorted.length >= 3) {
          this.top3Event = allEventsSorted[2];
        }
        if (allEventsSorted.length >= 4) {
          this.flop1Event = allEventsSorted[allEventsSorted.length - 1];
        }
        if (allEventsSorted.length >= 5) {
          this.flop2Event = allEventsSorted[allEventsSorted.length - 2];
        }
        if (allEventsSorted.length >= 6) {
          this.flop3Event = allEventsSorted[allEventsSorted.length - 3];
        }

        if (allEventsSorted.length >= 1) {
          this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], allEventsSorted[0]?.publicId).subscribe(value => {
            this.top1Event["attendanceCount"] = value.page.totalElements;
            this.data_donut_1.push(
              {
                "group": "Teilnahmen",
                "value": value.page.totalElements
              },
              {
                "group": "Nicht eingelöst",
                "value": allEventsSorted[0].totalActiveReservationsCount - value.page.totalElements
              }
            )
            this.data_donut_1 = [...this.data_donut_1];
          })
        }

        if (allEventsSorted.length >= 2) {
          this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], allEventsSorted[1]?.publicId).subscribe(value => {
            this.top2Event["attendanceCount"] = value.page.totalElements;
            this.data_donut_2.push({
              "group": "Teilnahmen",
              "value": value.page.totalElements
            },
              {
                "group": "Nicht eingelöst",
                "value": allEventsSorted[1].totalActiveReservationsCount - value.page.totalElements
              })

            this.data_donut_2 = [...this.data_donut_2];
          })
        }
        if (allEventsSorted.length >= 3) {
          this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], allEventsSorted[2]?.publicId).subscribe(value => {
            this.top3Event["attendanceCount"] = value.page.totalElements;
            this.data_donut_3.push(
              {
                "group": "Teilnahmen",
                "value": value.page.totalElements
              },
              {
                "group": "Nicht eingelöst",
                "value": allEventsSorted[2].totalActiveReservationsCount - value.page.totalElements
              })

            this.data_donut_3 = [...this.data_donut_3];
          })
        }

        if (allEventsSorted.length >= 4) {
          this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], this.flop1Event?.publicId).subscribe(value => {
            this.flop1Event["attendanceCount"] = value.page.totalElements;

            this.data_donut_1_flop.push({
              "group": "Teilnahmen",
              "value": value.page.totalElements
            },
              {
                "group": "Nicht eingelöst",
                "value": this.flop1Event.totalActiveReservationsCount - value.page.totalElements
              })

            this.data_donut_1_flop = [...this.data_donut_1_flop];
          });
        }
        if (allEventsSorted.length >= 5) {
          this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], this.flop2Event?.publicId).subscribe(value => {
            this.flop2Event["attendanceCount"] = value.page.totalElements;
            this.data_donut_2_flop.push(
              {
                "group": "Teilnahmen",
                "value": value.page.totalElements
              },
              {
                "group": "Nicht eingelöst",
                "value": this.flop2Event.totalActiveReservationsCount - value.page.totalElements
              })
            this.data_donut_2_flop = [...this.data_donut_2_flop];
          });
        }
        if (allEventsSorted.length >= 6) {
          this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], this.flop3Event?.publicId).subscribe(value => {
            this.flop3Event['attendanceCount'] = value.page.totalElements;
            this.data_donut_3_flop.push(
              {
                "group": "Teilnahmen",
                "value": value.page.totalElements
              },
              {
                "group": "Nicht eingelöst",
                "value": this.flop3Event.totalActiveReservationsCount - value.page.totalElements
              })
            this.data_donut_3_flop = [...this.data_donut_3_flop];
          });
        }
        this.LoadingFlopsAndTops = false;
      }
    })
  }
}